exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FriendsArticles__articleImage___1e1oP {\n  height: 100px;\n}\n.FriendsArticles__sharerImage___3M1TM {\n  height: 15px;\n}\n.FriendsArticles__article___3m4iM {\n  margin-bottom: 30px;\n}\n", ""]);
// Exports
exports.locals = {
	"articleImage": "FriendsArticles__articleImage___1e1oP",
	"sharerImage": "FriendsArticles__sharerImage___3M1TM",
	"article": "FriendsArticles__article___3m4iM"
};